import React from 'react';
import { pluralizer } from './utils/utils';
import PrintSizeSelector from './print-size-selector';

export default function MobileLoaderFooter({
  files,
  brokenPreviews,
  addPhotosDisabled,
  handleAddPhotosClick,
  onCancelClick,
  onErrorIconClick,
}) {
  return (
    <div className="w-100">
      <PrintSizeSelector />
      <div className="d-flex justify-content-between align-items-center buttons">
        <button
          aria-label="Cancel"
          className="btn btn-link mb-0 px-2 cancel"
          data-dismiss="modal"
          type="button"
          onClick={onCancelClick}>
          Cancel
        </button>
        <div className="d-flex flex-nowrap">
          <p className="selected-images-number m-0">
            {pluralizer(files.length, 'photo')} selected
          </p>
          {brokenPreviews.length > 0 && (
            <button
              className="btn btn-link m-0 h-auto errors-link"
              onClick={onErrorIconClick}>
              {pluralizer(brokenPreviews.length, 'error')}
              <span className="fa-stack text-dark icon ml-1">
                <i className="far fa-circle fa-stack-2x p-0" />
                <i className="fas fa-exclamation fa-stack-1x  p-0" />
              </span>
            </button>
          )}
        </div>
        <button
          aria-label="Add photos"
          className="btn btn-primary action mb-0 font-weight-bold"
          disabled={addPhotosDisabled || !files.length}
          type="button"
          onClick={handleAddPhotosClick}>
          Add
        </button>
      </div>
    </div>
  );
}
